module.exports = __webpack_public_path__ + "assets/img/group-logo-c051325f.png";